import { render } from "./ExportDownload.vue?vue&type=template&id=2de0e489&scoped=true"
import script from "./ExportDownload.vue?vue&type=script&lang=ts"
export * from "./ExportDownload.vue?vue&type=script&lang=ts"

import "./ExportDownload.vue?vue&type=style&index=0&id=2de0e489&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2de0e489"

export default script